import React from 'react';
// import data
import { teamData } from '../data';
//import motion
import {motion} from 'framer-motion'
//import vairants 
import { fadeIn } from '../variants';

const Team = () => {
  //destructure team data
  const { 
    pretitle,
    title,
    sub1,
    sub2,
    name,
    occupation,
    signatureImg,
    chefImg,
  } = teamData
  return <section className='select-none relative top-80 z-10 lg:top-[250px]
  min-h-[500px]'>
<div className="container mx-auto">
  {/* text and image wrapper */}
  <motion.div
  className="flex flex-col lg:flex-row h-full lg:grid-cols-[1fr_auto] lg:gap-x-[120px]"
>
  {/* text */}
  <motion.div
    variants={fadeIn('down', 'tween', 0.0, 1.6)}
    initial="hidden"
    whileInView="show"
    className="flex-1 text-center lg:text-left lg:pt-8"
  >
    <div className="pretitle">{pretitle}</div>
    <h2 className="h2 capitalize">{title}</h2>

    {/* mobile image */}
    <motion.div
      variants={fadeIn('up', 'tween', 0.4, 1.2)}
      initial="hidden"
      whileInView="show"
      className="lg:hidden my-6 px-20"
    >
      <img
        src={chefImg}
        alt=""
        className="w-full md:w-[400px] mx-auto rounded-xl"
      />
    </motion.div>

    <p className="mb-[15px]">{sub1}</p>
    <p className="mb-[60px]">{sub2}</p>
          <div className=' flex justify-center lg:justify-start'>
           <img 
          className='sm:max-w-[300px] -mt-10'
          src={signatureImg}/>
          </div>
          <div className='sm:ml-20 md:ml-2 text-xl capitalize font-semibold text-red-900'>{name}</div>
            <div className='sm:ml-20 md:ml-2 ml-3 text-[15px] font-semibold capitalize text-grey/70'>{occupation}</div>

    
  </motion.div>

  {/* desktop image */}
  <motion.div
    variants={fadeIn('up', 'tween', 0.6, 1.6)}
    initial="hidden"
    whileInView="show"
    className="hidden lg:flex items-center"
  >
    <img
      src={chefImg}
      alt=""
      className="w-[400px] max-w-full rounded-xl"
    />
  </motion.div>
</motion.div>

</div>

  </section>;
};

export default Team;


          //   <div className=' flex justify-center lg:justify-start'>
          // <img 
          // className='sm:max-w-[300px] -mt-10'
          // src={signatureImg}/>
          // </div>
          // <div className='sm:ml-20 md:ml-2 text-xl capitalize font-semibold text-red-900'>{name}</div>
          //   <div className='sm:ml-20 md:ml-2 ml-3 text-[15px] font-semibold capitalize text-grey/70'>{occupation}</div>
          // </div>